import {Component, Input} from '@angular/core';
import { WordpressCheckComponent} from '../../components/wordpress-check/wordpress-check.component';
import {NgForOf, NgIf} from '@angular/common';


@Component({
  selector: 'app-wordpress-details',
  standalone: true,
  imports: [WordpressCheckComponent, NgForOf, NgIf],
  templateUrl: './wordpress-details.component.html',
  styleUrl: './wordpress-details.component.css'
})
export class WordpressDetailsComponent {
 @Input() wordpressData: any = {};

  convertToArray(object:any) {

    const readerFriendlyNames = {
      "isWordPress": "WordPress",
      "hasWpIncludes": "Wp Includes",
      "hasWpContent": "Wp Content",
      "hasRestAPI": "Rest API",
      "hasLoginPage": "Login Page",
      "hasReadme": "WP Readme",
    }

    const mappedArray = Object.keys(object).map(key => {

      // @ts-ignore
      const friendlyName:string = readerFriendlyNames[key] || key;

      return {
        label: friendlyName,
        checked: object[key]
      }
    });
    return mappedArray;
  }
}
